import {createAction, props} from '@ngrx/store';
import {IYear} from '../models/IYearModel';
import {IStates} from '../models/IStatesModel';
import {IPriceDiscoveryModel} from '../models/IPriceDiscoveryModel';

export enum PriceDiscoveryActionTypes {
  UPDATE_CROPS = '[IPriceDiscovery] Update Crops',
  PRICE_DISCOVERY_RECEIVED = '[IPriceDiscover] Price Discovery Received'
}

export const UpdateCropsAction = createAction(
  PriceDiscoveryActionTypes.UPDATE_CROPS,
  props<{ year: IYear, state: IStates }>()
);

export const PriceDiscoveryReceived = createAction(
  PriceDiscoveryActionTypes.PRICE_DISCOVERY_RECEIVED,
  props<{ prices: Array<IPriceDiscoveryModel> }>()
);
